import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'codecSimplify', standalone: true })
export class CodecSimplifyPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    // Example: extract first part before slash or show full if simple
    return value.split('/')[0].trim();
  }
}
